import React from "react";
import "./styles.css";

export interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  subtitle?: string;
  className?: string;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  title,
  subtitle,
  className = "",
}) => {
  return (
    <div className={`step-indicator-container ${className}`}>
      <p className="step-indicator-text">
        Step {currentStep} of {totalSteps}
      </p>
      <h1 className="step-indicator-title">{title}</h1>
      {subtitle && <p className="step-indicator-subtitle">{subtitle}</p>}
    </div>
  );
};

export default StepIndicator;

